import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

export const useUnreadCount = () => {
  return useQuery({
    queryKey: ['unread-count'],
    queryFn: async () => {
      const response = await apiClient.get('/notifications/unread-count');
      return response.data;
    },
  });
};